// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s-t2","index":"styles_index__3pzaU"};